var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpertPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "#19324A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 117.375V107.625C112.5 102.453 110.446 97.4934 106.789 93.8364C103.132 90.1795 98.1717 88.125 93 88.125H54C48.8283 88.125 43.8684 90.1795 40.2114 93.8364C36.5545 97.4934 34.5 102.453 34.5 107.625V117.375",
    stroke: "#0A0E11",
    strokeOpacity: 0.4,
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 68.625C84.2696 68.625 93 59.8946 93 49.125C93 38.3554 84.2696 29.625 73.5 29.625C62.7304 29.625 54 38.3554 54 49.125C54 59.8946 62.7304 68.625 73.5 68.625Z",
    stroke: "#0A0E11",
    strokeOpacity: 0.4,
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertPlaceholder);
export default __webpack_public_path__ + "static/media/expertPlaceholder.7c4c3070ca157475541532ead6af46fe.svg";
export { ForwardRef as ReactComponent };